import { computed } from "vue";
import { useQuery } from '@tanstack/vue-query';

import { USER_API } from "@/constants/api";
import { fetchUserContainers } from "@/api/user";

import type { Container } from "@/types/containers";

function useUserContainers(userId: number) {
  const { data, isFetching, isError } = useQuery({
    queryKey: [USER_API],
    queryFn: () => fetchUserContainers({userId: userId}),
    select(data) {
      return data.data;
    }
  });

  const containers = computed<Container[]>(() => {
    return data.value ?? [];
  });

  return { containers, isFetching, isError };
}

export default useUserContainers;
